import { useState } from 'react'
import './Dashboard.css'
import './KPIs.css'

const KPI_PASSWORD = 'kpi2026'

const SECTIONS = [
  {
    id: 'neufs',
    titre: 'Ventes — Véhicules neufs',
    couleur: '#185FA5',
    kpis: [
      'Unités vendues',
      'Objectif mensuel',
      'Taux d\'atteinte objectif',
      'Profit brut moyen / unité',
      'Profit brut total',
      'Délai moyen de livraison',
      'CSI / Satisfaction client',
    ]
  },
  {
    id: 'usages',
    titre: 'Ventes — Véhicules d\'occasion',
    couleur: '#3B6D11',
    kpis: [
      'Unités vendues',
      'Objectif mensuel',
      'Taux d\'atteinte objectif',
      'Profit brut moyen / unité',
      'Profit brut total',
      'Ratio neuf / occasion',
      'Âge moyen de l\'inventaire (jours)',
      'Véhicules +60 jours en inventaire',
    ]
  },
  {
    id: 'service',
    titre: 'Département de service',
    couleur: '#C8102E',
    kpis: [
      'Nombre de ROs (ordres de réparation)',
      'Heures vendues',
      'Heures disponibles',
      'Efficacité techniciens (%)',
      'Absorption du service (%)',
      'Profit brut service',
      'CSI / Satisfaction service',
      'Taux de rétention clientèle',
    ]
  },
  {
    id: 'pieces',
    titre: 'Département des pièces',
    couleur: '#8B5CF6',
    kpis: [
      'Ventes totales pièces',
      'Profit brut pièces',
      'Taux de remplissage commandes',
      'Valeur de l\'inventaire',
      'Rotation de l\'inventaire',
      'Pièces obsolètes (%)',
    ]
  },
]

export default function KPIs() {
  const [unlocked, setUnlocked] = useState(false)
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')

  function handleUnlock(e) {
    e.preventDefault()
    if (password === KPI_PASSWORD) {
      setUnlocked(true)
    } else {
      setError('Code incorrect.')
    }
  }

  if (!unlocked) {
    return (
      <div className="kpi-lock-wrap">
        <div className="kpi-lock-card">
          <div className="kpi-lock-icon">🔒</div>
          <h2>Accès restreint</h2>
          <p>Cet onglet est en développement et protégé par un code d'accès.</p>
          <form onSubmit={handleUnlock}>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Code d'accès"
              autoFocus
            />
            {error && <div className="kpi-lock-error">{error}</div>}
            <button type="submit">Accéder</button>
          </form>
        </div>
      </div>
    )
  }

  return (
    <div className="kpis-page">
      <div className="page-header">
        <div>
          <h1>Tableau de bord KPIs</h1>
          <p>Indicateurs de performance — toutes départements</p>
        </div>
        <div className="construction-badge">🚧 En construction</div>
      </div>

      <div className="construction-banner">
        Cette section est en cours de développement. Les KPIs affichés ci-dessous représentent la structure prévue — les données seront intégrées prochainement.
      </div>

      <div className="kpis-grid">
        {SECTIONS.map(section => (
          <div key={section.id} className="kpi-section-card">
            <div className="kpi-section-header" style={{borderLeftColor: section.couleur}}>
              <h3 style={{color: section.couleur}}>{section.titre}</h3>
              <span className="kpi-coming-soon">À venir</span>
            </div>
            <div className="kpi-list">
              {section.kpis.map((kpi, i) => (
                <div key={i} className="kpi-row">
                  <span className="kpi-label">{kpi}</span>
                  <span className="kpi-value-placeholder">— —</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
